module.exports = __webpack_public_path__ + "static/media/dayDateHighlight.f1d67da6.svg";